export const isRetinaLikeDisplay = () => window.devicePixelRatio > 1;
